import { http, pagination, id } from 'utils'
import { SET_LOGS, SET_META } from 'vx/mutations'

const initialLogState = () => ({
  date: null,
  time: null,
  ip: null,
  user: null,
  action: null,
  content: null
})

// Logs state.
const state = {
  log: initialLogState(),
  logs: [],
  meta: null
}

// Logs state getters.
const getters = {}

// Logs actions
const actions = {
  /**
   * Get all logs.
   *
   * @return Promise
   */
  async getLogs ({ commit, state: { logs } }, { next = false, params = {}, type, target } = {}) {
    const targetId = id(target)

    if (!targetId) {
      return
    }

    if (next) {
      if (pagination(state.meta)) {
        return Promise.reject(new Error('No more results.'))
      }

      params.page = state.meta.current_page + 1
    } else {
      commit(SET_LOGS, [])
      commit(SET_META, null)
      params.page = null
    }

    const response = await http.get(`logs/${type}`, { params: { ...params, ...{ auditable_id: targetId } } })

    commit(SET_LOGS, next ? [...logs, ...response.data.data] : response.data.data)
    commit(SET_META, response.data.meta)

    return response
  }
}

// Logs state mutations.
const mutations = {
  [SET_LOGS] (state, logs) {
    state.logs = logs
  },

  [SET_META] (state, meta) {
    state.meta = meta
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}
